// extracted by mini-css-extract-plugin
module.exports = {"preview-loader":"Q_ds","previewLoader":"Q_ds"};